module.exports = __webpack_public_path__ + "img/mono_phuket.6409f449.jpg";